module.exports = flarum.reg.get('flarum-tags', 'forum/components/TagHero');